import {
  closestCorners,
  DndContext,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import React, { useEffect, useState } from "react";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Container from "./Container/Container";
import Items from "./Container/Items";

const RequestPopupBody = () => {
  const [containers, setContainers] = useState([
    {
      id: "container-1",
      title: "First Container",
      items: [
        {
          id: "item-1",
          title: "Vehicle Name",
          odometer: "0KM",
          plate: "Plate Number",
          distance: 10000,
          min_date: "11/2/2025",
        },
      ],
    },
    {
      id: "container-2",
      title: "Second Container",
      items: [
        {
          id: "item-2",
          title: "Vehicle Name2",
          odometer: "0KM",
          plate: "Plate Number",
          distance: 10000,
          min_date: "11/2/2025",
        },
        {
          id: "item-3",
          title: "Vehicle Name3",
          odometer: "0KM",
          plate: "Plate Number",
          distance: 10000,
          min_date: "11/2/2025",
        },
      ],
    },
  ]);
  const [activeId, setActiveId] = useState(null);
  const [currentContainerId, setCurrentContainerId] = useState();
  const [containerName, setContainerName] = useState("");
  const [itemName, setItemName] = useState("");
  const [showAddContainerModal, setShowAddContainerModal] = useState(false);
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelectItem = (id) => {
    setSelectedIds((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id]
    );
  };

  const moveSelectedTo = (targetContainerId) => {
    setContainers((prevContainers) => {
      const updatedContainers = [...prevContainers];

      const sourceContainer = updatedContainers.find((container) =>
        container.items.some((item) => selectedIds.includes(item.id))
      );
      const targetContainer = updatedContainers.find(
        (container) => container.id === targetContainerId
      );

      // If no sourceContainer is found or sourceContainer and targetContainer are the same, do nothing
      if (!sourceContainer || sourceContainer.id === targetContainer.id) {
        setSelectedIds([]);
        return updatedContainers;
      }

      const movedItems = sourceContainer.items.filter((item) =>
        selectedIds.includes(item.id)
      );
      targetContainer.items = [...targetContainer.items, ...movedItems];

      sourceContainer.items = sourceContainer.items.filter(
        (item) => !selectedIds.includes(item.id)
      );

      setSelectedIds([]);
      return updatedContainers;
    });
  };

  const findValueOfItems = (id, type) => {
    if (type === "container") {
      return containers.find((container) => container.id === id);
    }
    if (type === "item") {
      return containers.find((container) =>
        container.items.find((item) => item.id === id)
      );
    }
  };

  const handleDragStart = (event) => {
    const { active } = event;
    const { id } = active;
    setActiveId(id);
  };

  const handleDragMove = (event) => {
    const { active, over } = event;
    if (
      active.id.toString().includes("item") &&
      over?.id.toString().includes("item") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      const activeContainer = findValueOfItems(active.id, "item");
      const overContainer = findValueOfItems(over.id, "item");
      if (!activeContainer || !overContainer) return;
      const activeContainerIndex = containers.findIndex(
        (container) => container.id === activeContainer.id
      );
      const overContainerIndex = containers.findIndex(
        (container) => container.id === overContainer.id
      );
      const activeItemIndex = activeContainer.items.findIndex(
        (item) => item.id === active.id
      );
      const overItemIndex = overContainer.items.findIndex(
        (item) => item.id === over.id
      );
      if (activeContainerIndex === overContainerIndex) {
        let newItems = [...containers];
        newItems[activeContainerIndex].items = arrayMove(
          newItems[activeContainerIndex].items,
          activeItemIndex,
          overItemIndex
        );
        setContainers(newItems);
      } else {
        let newItems = [...containers];
        const [removedItem] = newItems[activeContainerIndex].items.splice(
          activeItemIndex,
          1
        );
        newItems[overContainerIndex].items.splice(
          overItemIndex,
          0,
          removedItem
        );
        setContainers(newItems);
      }
    }
    if (
      active.id.toString().includes("item") &&
      over?.id.toString().includes("container") &&
      active &&
      over &&
      active.id !== over.id
    ) {
      const activeContainer = findValueOfItems(active.id, "item");
      const overContainer = findValueOfItems(over.id, "container");

      if (!activeContainer || !overContainer) return;
      const activeContainerIndex = containers.findIndex(
        (container) => container.id === activeContainer.id
      );
      const overContainerIndex = containers.findIndex(
        (container) => container.id === overContainer.id
      );
      const activeItemIndex = containers.findIndex(
        (item) => item.id === active.id
      );
      let newItems = [...containers];
      const [removedItem] = newItems[activeContainerIndex].items.splice(
        activeItemIndex,
        1
      );
      newItems[overContainerIndex].items.push(removedItem);
      setContainers(newItems);
    }
  };

  const moveAllTo = (targetContainerId) => {
    setContainers((prevContainers) => {
      const updatedContainers = [...prevContainers];

      // Identify source and target containers
      const sourceContainer = updatedContainers.find(
        (container) => container.id !== targetContainerId
      );
      const targetContainer = updatedContainers.find(
        (container) => container.id === targetContainerId
      );

      if (sourceContainer && targetContainer) {
        // Move all items to the target container
        targetContainer.items = [
          ...targetContainer.items,
          ...sourceContainer.items,
        ];
        sourceContainer.items = []; // Clear source container
      }

      return updatedContainers;
    });
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );
  return (
    <div className="maintanence-container">
      <DndContext
        sensors={sensors}
        onDragStart={handleDragStart}
        onDragEnd={handleDragMove}
        collisionDetection={closestCorners}
      >
        <div className="maintanence-layout">
          {/* Available Vehicles */}
          <div className="big-container">
            <Container title={"Available Vehicles"} id={"container-1"}>
              <SortableContext
                items={containers[0].items.map((item) => item.id)}
                strategy={verticalListSortingStrategy}
              >
                <div className="dnd-container">
                  {containers[0].items.map((item) => (
                    <Items
                      key={item.id}
                      id={item.id}
                      title={item.title}
                      odometer={item.odometer}
                      plate={item.plate}
                      distance={item.distance}
                      date={item.min_date}
                      selected={selectedIds.includes(item.id)} // Check if selected
                      toggleSelectItem={toggleSelectItem}
                    />
                  ))}
                </div>
              </SortableContext>
            </Container>
          </div>
          {/* Controls Section */}
          <div className="controls-section">
            <button
              className={
                containers[0].items.some((item) =>
                  selectedIds.includes(item.id)
                )
                  ? `controls-2`
                  : "controls-1"
              }
              onClick={() => moveSelectedTo("container-2")}
            >
              {containers[0].items.some((item) =>
                selectedIds.includes(item.id)
              ) ? (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/insert-active.svg`}
                  alt="insert"
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/insert.svg`}
                  alt="insert"
                />
              )}
            </button>
            <button
              className="controls-2"
              onClick={() => moveAllTo("container-2")}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/froward.svg`}
                alt="froward"
              />
            </button>
            <button
              className={
                containers[1].items.some((item) =>
                  selectedIds.includes(item.id)
                )
                  ? `controls-2`
                  : "controls-1"
              }
              onClick={() => moveSelectedTo("container-1")}
            >
              {containers[1].items.some((item) =>
                selectedIds.includes(item.id)
              ) ? (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/back-active.svg`}
                  alt="back"
                />
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/assets/back.svg`}
                  alt="back"
                />
              )}
            </button>
            <button
              className="controls-2"
              onClick={() => moveAllTo("container-1")}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/backward.svg`}
                alt="backward"
              />
            </button>
          </div>

          {/* Second Container */}
          <div className="big-container">
            <Container title={"Assigned Vehicles"} id={"container-2"}>
              <SortableContext
                items={containers[1].items.map((item) => item.id)}
                strategy={verticalListSortingStrategy}
              >
                <div className="dnd-container">
                  {containers[1].items.map((item) => (
                    <Items
                      key={item.id}
                      id={item.id}
                      title={item.title}
                      odometer={item.odometer}
                      plate={item.plate}
                      distance={item.distance}
                      date={item.min_date}
                      selected={selectedIds.includes(item.id)} // Check if selected
                      toggleSelectItem={toggleSelectItem}
                    />
                  ))}
                </div>
              </SortableContext>
            </Container>
          </div>
        </div>
      </DndContext>
    </div>
  );
};

export default RequestPopupBody;
